import { render, staticRenderFns } from "./notifyClerkViewer.vue?vue&type=template&id=8f75e076&scoped=true"
import script from "./notifyClerkViewer.vue?vue&type=script&lang=js"
export * from "./notifyClerkViewer.vue?vue&type=script&lang=js"
import style0 from "./notifyClerkViewer.vue?vue&type=style&index=0&id=8f75e076&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f75e076",
  null
  
)

export default component.exports